import { render, staticRenderFns } from "./ApplyJudge.vue?vue&type=template&id=9edbe082&scoped=true&"
import script from "./ApplyJudge.vue?vue&type=script&lang=js&"
export * from "./ApplyJudge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edbe082",
  null
  
)

export default component.exports